import React from 'react';
import { toaster } from 'evergreen-ui';

import updateOrder from '../../../../actions/orders/updateOrder';
import { Heading } from '../../../../styleguide';
import { useSession } from '../../../../hooks';
import { TabContentWrapper } from '../../../../styles/shop';
import {
  OrdersListWrapper,
  EmptyNewOrders,
} from '../../../../styles/orders-cards';
import TabPanel from '../../../shop/tabs/TabPanel';
import { InProgressOrderCard } from '../cards/Cards';
import AttributionDialog from '../dialogs/AttributionDialog';
import EmptyTab from './EmptyTab';

const InProgressTab = props => {
  const { value, orders, onCancelOrder } = props;
  const [confirmModal, setConfirmModal] = React.useState(null);
  const [selectedOrder, setSelectedOrder] = React.useState(null);
  const { user } = useSession();

  const hasExistingOrders = !!orders.length;

  React.useEffect(() => {
    if (!!selectedOrder && !!confirmModal) {
      const orderToUpdate = orders.find(o => o.id === selectedOrder.id);

      if (!orderToUpdate || !!orderToUpdate?.inTreatment) {
        setConfirmModal(null);
        return;
      }
    }
  }, [orders, selectedOrder, confirmModal]);

  const onConfirm = async order => {
    try {
      const orderToUpdate = orders.find(o => o.id === order.id);

      if (!orderToUpdate || !!orderToUpdate?.inTreatment) {
        setConfirmModal(null);
        toaster.warning(
          `⏳ Impossible commande en cours de traitement, réessayez plus tard`
        );
        return;
      }

      await updateOrder(orderToUpdate, {
        rusher: {
          isAdmin: true,
          available: true,
          isWorked: true,
          isVerified: true,
          name: user.name,
          id: user.id,
          phone: user.phone,
          pictureURL: '',
        },
      });
      toaster.success(`Commande attribué 🚀`, {
        description: `La commande numéro ${order.id} vous est desormais attribué.`,
      });
      setConfirmModal(null);
    } catch (error) {
      setConfirmModal(null);
      toaster.danger(`Une erreur est survenue`, {
        description:
          error.message ||
          `Impossible d'attribuer la commande ${order.id} à ${user.name}`,
      });
    }
  };

  const onClickRemoveRusher = async order => {
    try {
      const orderToUpdate = orders.find(o => o.id === order.id);

      if (!orderToUpdate || !!orderToUpdate?.inTreatment) {
        toaster.warning(
          `⏳ Impossible commande en cours de traitement, réessayez plus tard`
        );
        return;
      }

      if (!orderToUpdate.rusher) {
        toaster.warning(
          `⏳ Impossible commande en cours de traitement, réessayez plus tard`
        );
        return;
      }

      await updateOrder(order, {
        rusher: null,
      });
      toaster.success(`Livreur retiré ✅`, {
        description: `La commande numéro ${order.id} n'est plus attribué à ${order.rusher.name}.`,
      });
    } catch (error) {
      toaster.danger(`Une erreur est survenue`, {
        description: error.message || `Impossible de retirer le livreur.`,
      });
    }
  };

  return (
    <TabPanel value={value} index={1}>
      <TabContentWrapper>
        {hasExistingOrders ? (
          <>
            <Heading size={800}>En cours de préparation</Heading>

            <OrdersListWrapper>
              {orders.map(order => {
                return (
                  <InProgressOrderCard
                    key={order.id}
                    order={order}
                    onClickConfirm={() => {
                      setConfirmModal(true);
                      setSelectedOrder(order);
                    }}
                    onCancelOrder={onCancelOrder}
                    onClickRemoveRusher={onClickRemoveRusher}
                  />
                );
              })}
            </OrdersListWrapper>

            {!!confirmModal ? (
              <AttributionDialog
                isOpen={!!confirmModal}
                selectedOrder={selectedOrder}
                confirmModal={confirmModal}
                onClose={() => setConfirmModal(null)}
                onConfirm={() => onConfirm(selectedOrder)}
              />
            ) : null}
          </>
        ) : (
          <EmptyNewOrders>
            <EmptyTab
              title={'Pas de commande en cours'}
              description={
                'Les commandes en cours sont vos commandes en cours de préparation 🥘'
              }
            />
          </EmptyNewOrders>
        )}
      </TabContentWrapper>
    </TabPanel>
  );
};

export default InProgressTab;
